/** Teselas de OpenStreetMap por defecto; `VITE_TILES_URL` las cambia en el build (RF-50). */
export const TESELAS_OSM = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'

export function urlTeselas(entorno: { VITE_TILES_URL?: string } = import.meta.env as { VITE_TILES_URL?: string }): string {
  const propia = entorno.VITE_TILES_URL?.trim()
  return propia ? propia : TESELAS_OSM
}
